var _path, _path2, _g, _path3, _path4, _rect, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnDashboardCaptivePortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.75H49C49.6904 14.75 50.25 15.3096 50.25 16V44C50.25 44.6904 49.6904 45.25 49 45.25H11C10.3097 45.25 9.75 44.6903 9.75 44V16C9.75 15.3096 10.3096 14.75 11 14.75Z",
    fill: "url(#paint0_linear_5962_126206)",
    stroke: "#BEBEBE",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21H50",
    stroke: "#BEBEBE",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7824 27.6515C26.3268 26.5747 28.1425 25.9999 30 25.9999C32.4908 25.9999 34.8795 27.0324 36.6408 28.8703C37.7536 30.0315 38.5583 31.4542 39 32.9999C38.7332 33.9336 38.3331 34.8257 37.8087 35.6446C36.7768 37.2562 35.31 38.5123 33.594 39.254C31.8779 39.9958 29.9896 40.1898 28.1678 39.8117C26.346 39.4336 24.6726 38.5002 23.3592 37.1296C22.2532 35.9755 21.4443 34.555 21 32.9999C21.0918 32.6786 21.1997 32.3614 21.3234 32.0496C22.0342 30.2589 23.238 28.7284 24.7824 27.6515Z",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 30C29.4067 30 28.8266 30.1759 28.3333 30.5056C27.8399 30.8352 27.4554 31.3038 27.2284 31.8519C27.0013 32.4001 26.9419 33.0033 27.0576 33.5853C27.1734 34.1672 27.4591 34.7018 27.8787 35.1213C28.2982 35.5409 28.8328 35.8266 29.4147 35.9424C29.9967 36.0581 30.5999 35.9987 31.1481 35.7716C31.6962 35.5446 32.1648 35.1601 32.4944 34.6667C32.8241 34.1734 33 33.5933 33 33C33 32.2043 32.6839 31.4413 32.1213 30.8787C31.5587 30.3161 30.7957 30 30 30Z",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 17L45.5 19",
    stroke: "#BEBEBE",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 17L47.5 19",
    stroke: "#BEBEBE",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 17,
    width: 2.25,
    height: 2.25,
    stroke: "#BEBEBE",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 18H37.2",
    stroke: "#BEBEBE",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5962_126206",
    x1: 30,
    y1: 14,
    x2: 30,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221054,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221154,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDashboardCaptivePortal);
export default __webpack_public_path__ + "static/media/icn_dashboard_captive_portal.628111ff59b63e677d463578814ab259.svg";
export { ForwardRef as ReactComponent };